import { sendRequest } from '../api/gas';
export default async (inviteId, logger) => {
    return sendRequest(`invite/${inviteId}`, 'resend', undefined, logger);
};
